var exports = {
  "k": "x127c5a35--332d0c--container",
};

module.exports = exports;
